import { setOptions } from '@googlemaps/js-api-loader';
import type { Plugin } from 'vue';
import { GEO_CONFIG_KEY } from './geo.config.ts';
import { installGoogleMapsAuthFailureHandler } from './google-maps-auth.ts';
import type { GeoPluginOptions } from './places.types.ts';

let mapsOptionsSet = false;

export const GeoPlugin: Plugin<GeoPluginOptions> = (
  app,
  { googleMapsApiKey, googleMapId, language = 'it', region = 'it' } = {},
) => {
  const key = googleMapsApiKey?.trim() ?? '';

  if (key && !mapsOptionsSet) {
    setOptions({ key, v: 'quarterly', language, region });
    installGoogleMapsAuthFailureHandler();
    mapsOptionsSet = true;
  }

  app.provide(GEO_CONFIG_KEY, {
    googleMapsApiKey: key,
    googleMapId: googleMapId?.trim() ?? '',
    language,
    region,
  });
};
